import React, { FC, useContext, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { Paper } from 'components/shared/surfaces/Paper/Paper';
import { Page } from 'components/layout/panel/Page/Page';
import { DistrictsBrowserContainer } from 'components/schoolDistricts/DistrictsBrowser/DistrictsBrowserContainer';

import { useStyles } from './DistrictsList.styles';
import { LocaleContext } from 'context/locale';
import { DistrictsListViewState } from './DistrictsList.types';

export const DistrictsListView: FC = () => {
  const { trans } = useContext(LocaleContext);
  const classes = useStyles();
  const location = useLocation();
  const state = location.state as DistrictsListViewState | null;
  const initialDatabaseId = state ? state.databaseId : null;

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.SCHOOL-DISTRICTS.DISTRICTS')} static />
      <Breadcrumb label={trans('BREADCRUMB.SCHOOL-DISTRICTS.DISTRICTS-LIST')} static />

      <Page title={trans('SCHOOL_DISTRICTS.DISTRICTS-LIST.TITLE')}>
        <Paper innerSpacing={2} outerSpacing={[0, 2, 2]} className={classes.paper}>
          <DistrictsBrowserContainer initialDatabaseId={initialDatabaseId} />
        </Paper>
      </Page>
    </Fragment>
  );
};
